import React, { createContext } from "react";

const FormStepContext = createContext({});

export default FormStepContext;
